import { render, staticRenderFns } from "./MasInformacion.vue?vue&type=template&id=33b4b5ee&name=mas-informacion&"
var script = {}
import style0 from "./MasInformacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports